import React, { lazy, Suspense } from 'react';
import { Shell } from './Shell';

const SpatialShell = lazy(() =>
  import('./SpatialShell').then((m) => ({ default: m.SpatialShell }))
);

function hasWebGL2(): boolean {
  try {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('webgl2');
    return ctx !== null;
  } catch {
    return false;
  }
}

export const WebGLCheck: React.FC = () => {
  const webgl = hasWebGL2();

  if (!webgl) {
    return <Shell />;
  }

  return (
    <Suspense fallback={<div style={{ backgroundColor: 'var(--bg-primary, #0E1420)', width: '100vw', height: '100vh' }} />}>
      <SpatialShell />
    </Suspense>
  );
};
